module.exports = __webpack_public_path__ + "assets/img/DS-room1 (3).3577a12e.jpg";